<template>
    <div class="container ">
         <form>
        <div class="row ">
            <h3 class="text-center mt-4">რეგისტრაცია</h3>

            <div class="col-6 mt-3">
  
              
  <div class="mb-3">
  
    <input type="text" class="form-control" placeholder="სახელი" v-model="fname">
   
  </div>
  <div class="mb-3">
  
    <input type="text" class="form-control" placeholder="გვარი" v-model="lname">
  </div>

    <div class="mb-3">
  
    <input type="text" class="form-control" placeholder="სახელი EN" v-model="fnameeng">
   
  </div>
  <div class="mb-3">
  
    <input type="text" class="form-control"  placeholder="გვარი EN" v-model="lnameeng">
  </div>
<div class="mb-3">

     <label for="start">დაბადების თარიღი: </label> 

      <input type="date" class="form-control" v-model="date"/>
   </div>
  
      <div class="mb-3">
  
    <input type="text" class="form-control" placeholder="ID ბარათი" v-model="IDcard">
   
  </div>
      <div class="mb-3">
  
    <input type="text" class="form-control"  placeholder="პირადობის ნომერი" v-model="pn">
   
  </div>

 <div class="mb-3">
   <input type="text" class="form-control"  placeholder="მისამართი" v-model="address">
  </div>
   <div class="mb-3">
  
    <input type="text" class="form-control"  placeholder="დაბადების ადგილი" v-model="birthplace">
   
  </div>
 
    
<div class="mb-3">
  <select class="form-select" v-model="citizenshipID">
  <option value="0">მოქალაქეობა...</option>
  <option :value="citizenship.citizenshipID" v-for="citizenship in citizenships" :key="citizenship.citizenshipID ">{{citizenship.citizenship}}</option>
 

</select>
</div>


    </div>


            <div class="col-6   ">

              
  <div class="mb-3">
    <p>სურათი <span style="color:red">(.jpg)</span></p>
              <input type="file" class="form-control" @change="getPhoto">
  </div>
  <div class="mb-3">
  <select class="form-select" v-model="positionID">
  <option value="0">პოზიცია...</option>
  <option :value="position.positionID" v-for="position in poistions" :key="position.positionID">{{ position.position }}</option>
  
</select>
  </div>

  <div class="mb-3">
   <h6>სქესი:</h6>
    <label class="form-check-label" for="exampleRadios1">მდედრ.  </label> 

  <input class="form-check-input ms-2" type="radio" name="gender"  value="0" v-model="gender">

      <label class="form-check-label ms-2" for="exampleRadios1">მამრ.</label> 
  
  <input class="form-check-input ms-2" type="radio" name="gender" value="1" v-model="gender">
  </div>
   <div class="mb-3">
  
    <input type="email" class="form-control" placeholder="Email" v-model="email">
   
  </div>

 <div class="mb-3">
    <input type="number"  class="form-control" placeholder="მობილური" v-model="phone">
 </div>


 <div class="mb-3">

<label for="start">დიპლომი/ცნობა <span style="color:red">(.pdf)</span>: </label> 

 <input type="file" class="form-control" @change="getdiploma" />
</div>


<div class="mb-3">

<label for="start">CV ატვირთვა <span style="color:red">(.pdf)</span>: </label> 

 <input type="file" class="form-control" @change="getCV"/>
</div>

<div class="mb-3">

<label for="start">სამინისტროს საბუთები <span style="color:red">(.zip)</span>: </label> 

 <input type="file" class="form-control" @change="getotherdocuments" />
</div>
 

 <div class="mb-3">

     <label for="start">საპენსიო სქემაში მონაწილეობა:</label> 

 <input class="form-check-input  ms-2" type="radio" name="pensia"  v-model="pensia" value="1">

  <label class="form-check-label  ms-2" for="flexRadioDefault1">
    კი
  </label>

   <input class="form-check-input  ms-2" type="radio" name="pensia" v-model="pensia" value="0">

  <label class="form-check-label  ms-2" for="flexRadioDefault1">
  არა
  </label>
    



 </div>
<div class="d-grid gap-2">
 
  <button class="btn btn-registration" type="button" @click="savePerson()">რეგისტრაცია</button>
</div>


                




            </div>

        </div>
         </form>
    </div>
</template>
<script>
    import HttpRequests from '../httpRequests/httpRequests';
    const httpRequests=new HttpRequests()
    
    export default{
      data(){
        return{
          positions:[],
          citizenships:[],
          fname:null,
          lname:null,
          fnameeng:null,
          lnameeng:null,
          date:null,
          IDcard:null,
          pn:null,
          address:null,
          birthplace:null,
          gender:1,
          email:null,
          phone:null,
          pensia:1,
          photo:null,
          diploma:null,
          CV:null,
          otherdocuments:null,
          positionID:0,
          citizenshipID:0

        }
      },
      mounted(){
        httpRequests.getPositions().then(response=>{
          this.poistions=response.data
        })
        httpRequests.citizenship().then(response=>{

          this.citizenships=response.data
        })
      },
      methods:{
        getPhoto(event){

          this.photo=event.target.files[0]
        },
        getdiploma(event){
          this.diploma=event.target.files[0]
        },
        getCV(event){
          this.CV=event.target.files[0]
        },
        getotherdocuments(event){
          this.otherdocuments=event.target.files[0]
        },
        savePerson(){
           

          let formData=new FormData()

          formData.append('lname',this.lname)
          formData.append('fname',this.fname)
          formData.append('fnameeng',this.fnameeng)
          formData.append('lnameeng',this.lnameeng)
          formData.append('date',this.date)
          formData.append('email',this.email)
          formData.append('address',this.address)
          formData.append('phone',this.phone)
          formData.append('birthplace',this.birthplace)
          formData.append('gender',this.gender)
          formData.append('pensia',this.pensia)
          formData.append('diploma',this.diploma)
          formData.append('otherdocuments',this.otherdocuments)
          formData.append('CV',this.CV)
          formData.append('pn',this.pn)
          formData.append('photo',this.photo)
          formData.append('IDcard',this.IDcard)
          formData.append('citizenshipID',this.citizenshipID)
          formData.append('positionID',this.positionID)


          httpRequests.savePerson(formData).then(()=>{
            location.reload()
          })

        }
      }
    }


</script>